
import { ResendReleasePaymentHoldEntity } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldEntity";
import { EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA, ResendReleasePaymentHoldSearchCriteria } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldSearchCriteria";


export interface ResendReleasePaymentHoldModel {
    isLoading: boolean,
    resendReleasePaymentHoldList: ResendReleasePaymentHoldEntity[],
    selectedRows: ResendReleasePaymentHoldEntity[],
    isShowSearchPanel: boolean,
    isAllowAutoSearch: boolean,
    searchCriteria: ResendReleasePaymentHoldSearchCriteria,
    forceRefresh: boolean,
    isSearchLoading: boolean,
    isShowUpdatePanel: boolean,
    agentDeliveryDate: Date | null,
    allFormState?: { [x: string]: string },
}

export const EMPTY_RESEND_RELEASE_PAYMENT_HOLD_MODEL: ResendReleasePaymentHoldModel = {
    isLoading: false,
    resendReleasePaymentHoldList: [],
    isShowSearchPanel: false,
    searchCriteria: EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA,
    selectedRows: [],
    isAllowAutoSearch: true,
    forceRefresh: false,
    isSearchLoading: true,
    isShowUpdatePanel: false,
    agentDeliveryDate: null,
    allFormState: {},
}